const states = {
	staff:{
		layout:{
			title:''
		},
		detailForm:{
			orderId:'',
			orderType:''
		}
	},
	navList : null,
	wxConfig : null
};

export default states;